import React, { useState } from 'react';
import { PopoverMenu } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import { useKfaTitle } from '../../hooks/useKfaTitle';
import ObjectInjestPopoverContent from './ObjectInjestPopoverContent';

const ObjectInjestPopover = ({
  onInsertText = () => {},
  onPopover = () => {},
  onInsertExcelOrPPT = () => {},
  onInsertPowerBi = () => {},
  onInsertTableau = () => {},
  allowTextOnly,
  isPowerBiEnabled,
  buttonTitle,
}) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const kfa = useKfaTitle();

  const buttonTitleLocal = buttonTitle || t('addContentDetail', { kfa });

  const handlePopoverChange = (nextShow) => {
    setShow(nextShow);
    onPopover(nextShow);
  };

  return (
    <PopoverMenu
      buttonText={buttonTitleLocal}
      buttonIconName="plus"
      buttonIconClass="outline icon-orange"
      placement="bottom"
      show={show}
      onToggle={handlePopoverChange}
    >
      <ObjectInjestPopoverContent
        onCancel={() => handlePopoverChange(false)}
        onInsertText={onInsertText}
        onInsertPowerBi={onInsertPowerBi}
        onInsertTableau={onInsertTableau}
        onInsertExcelOrPPT={onInsertExcelOrPPT}
        allowTextOnly={allowTextOnly}
        isPowerBiEnabled={isPowerBiEnabled}
      />
    </PopoverMenu>
  );
};

export default ObjectInjestPopover;
